.goalCard:hover {
	border-color: rgb(72, 64, 190);
	cursor: pointer;
}
